import React from 'react';
import { Link } from 'react-router-dom';
import { projects } from '@/projects';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { getLocalizedText, normalizeLang, sanitizeText } from '@/lib/format';

const featuredIds = [1, 2, 4]; // IDs de proyectos destacados

const FeaturedProjects = () => {
  const { t, i18n } = useTranslation();
  const lang = normalizeLang(i18n.language);
  const featuredProjects = projects.filter(project => featuredIds.includes(project.info.id));

  return (
    <section className="py-24 bg-[#2A2A2A]">
      <div className="container-custom">
        <motion.h2
          className="section-title text-[#F5F5F5] text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {t('home.featuredTitle')}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {featuredProjects.map((project, index) => (
            <motion.div
              key={project.slug}
              className="bg-[#222222] rounded overflow-hidden shadow-md hover:shadow-lg transition-all group"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <Link to={`/projects/${project.info.id}`}>
                <div className="overflow-hidden">
                  <img
                    src={project.info.cover}
                    alt={project.info.title}
                    className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-poppins text-[#F5F5F5] mb-2 transition-colors duration-300 group-hover:text-[#C8102E]">
                    {sanitizeText(project.info.title)}
                  </h3>
                  <p className="text-sm font-engram text-[#CCCCCC]">
                    {sanitizeText(getLocalizedText(project.info.category, lang))}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
